"use client"

import { useState } from "react"
import Image from "next/image"

type Logo = { src: string; alt: string }

export default function SponsorsMarquee({ logos }: { logos: Logo[] }) {
  const [isPaused, setIsPaused] = useState(false)

  if (logos.length === 0) return null

  return (
    <div
      className="relative mt-2"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent z-10" />

      {/* Marquee track */}
      <div
        className="flex w-max gap-4 py-2"
        style={{
          animation: "scroll-x 120s linear infinite",
          animationPlayState: isPaused ? "paused" : "running",
        }}
      >
        {[...logos, ...logos].map((logo, i) => (
          <div
            key={`${logo.src}-${i}`}
            className="flex items-center justify-center h-24 w-40 shrink-0 transition-all duration-300 hover:scale-110"
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              width={220}
              height={110}
              className="h-20 w-auto object-contain"
              style={{ maxWidth: "180px" }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
